<template>
  <info-panel
    :previewId="id"
    :collapsible="true"
    :info-panel-header="$t('allowTeamAccess')"
  >
    <div slot="info">
      <tag
          :name="team.displayName"
          :is-removable="true"
          icon-left="users"
          @removeTag="removeTeam"
          v-for="(team, index) in teams"
          :key="index"
          :tag="team"
          :organization-id="team.organizationId"
      />
      <universal-selector
          class="mt-2"
          @addItem="addTeam"
          :exclude-from-item-list="teams"
          list-name="userTeamList"
          store-name="Team"
          filter-attribute="displayName"
          :limit-by-organization-id="limitByOrganizationId"
          tag-icon="users"
          :show-organization="true"
          :after-query-filter="function (item) {return item.visibility > 0 || item.ownerId === $store.getters.getCurrentUserId}"
      />
      <div class="w-100" />
      <child-resources
        :target-id="id"
        :store-name="storeName"
      />
    </div>
  </info-panel>
</template>

<script>
import UniversalSelector from "@/components/organizations/UniversalSelector";
import Tag from "@/components/Tag";
import InfoPanel from "@/components/InfoPanel";
import ChildResources from "@/components/organizations/ChildResources";
export default {
  name: "TeamAttacher",
  components: {
    UniversalSelector,
    Tag,
    InfoPanel,
    ChildResources
  },
  props: {
    teams: {type: Array, default: () => {return []}},
    id: {type: String, required: true},
    /**
     * @organizationId limit entries for a spezific organization
     * */
    limitByOrganizationId: {type: String, default: ''},
    storeName: {type: String, required: true}
  },
  data() {
    return {

    };
  },
  methods: {
    addTeam(team) {
      this.$store.dispatch(`clientAdd${this.storeName}Resource`, {
        id: this.id,
        params: [team.id],
      }).then(() => {
        this.$emit('added');
      })
    },
    removeTeam(team) {
      this.$store.dispatch(`clientRemove${this.storeName}Resource`, {
        id: this.id,
         params: [team.id],
      }).then(() => {
        this.$emit('removed');
      })
    },
  }
}
</script>